import { ModalBackground, ModalCard } from "../hometab/styles";
import SubmitButton from "../../atoms/submitbutton";
import { useState } from "react";
import { Heading, Input } from "./styles";
import { aboutSchema } from "../../../validations/about";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL } from "../../../constants";
import { useForm } from "react-hook-form";

interface AboutProps {
  toggleClear: () => void;
  profile: any;
  refresh: boolean;
  setRefresh: any;
}

type FormData = yup.InferType<typeof aboutSchema>;

function AboutModal({ toggleClear, profile, refresh, setRefresh }: AboutProps) {
  const [isloading, setisloading] = useState(false);
  let businessUuid = useSelector((state: any) => state.auth.uuid);

  const { register, handleSubmit, formState, reset } = useForm<FormData>({
    resolver: yupResolver(aboutSchema),
    defaultValues: {
      about: profile?.description,
    },
  });
  const { errors } = formState;

  const createRequest = (data: any) => {
    setisloading(true);

    let formData: any = {
      businessUuid: businessUuid,
      description: data.about,
    };
    axios
      .post(`${API_URL}/update/description`, formData)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setisloading(false);
          toast.success(response.data.message);
          reset();
          toggleClear();
          setRefresh(!refresh);
        }
      })
      .catch((error) => {
        setisloading(false);

        if (error?.response?.status === 400 || error?.response?.status === 401) {
          toast.error(error?.response?.data?.message);
          return;
        }
        toast.error("Connection Failed");
      });
  };

  return (
    <ModalBackground onClick={toggleClear}>
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <div>
          <Heading>About</Heading>
          <form onSubmit={handleSubmit(createRequest)}>
            <Input placeholder="Write a compelling description of your brand or business" {...register("about")} />
            {errors?.about && <p className="text-xs mb-2 text-red-600">{errors.about?.message}</p>}
            <SubmitButton isloading={isloading} value="Save" width="19.6em" />
          </form>
        </div>
      </ModalCard>
    </ModalBackground>
  );
}

export default AboutModal;
